module.exports = __webpack_public_path__ + "img/ico_allenatore.55126f36.png";